module.exports = __webpack_public_path__ + "img/earn_nav_dark.6bcf58f6.svg";